import { render, staticRenderFns } from "./ISARoomset.vue?vue&type=template&id=205c1463&scoped=true&"
import script from "./ISARoomset.vue?vue&type=script&lang=js&"
export * from "./ISARoomset.vue?vue&type=script&lang=js&"
import style0 from "./ISARoomset.vue?vue&type=style&index=0&id=205c1463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c1463",
  null
  
)

export default component.exports